import { jsx as x } from "react/jsx-runtime";
import "react";
import { classNames as p } from "../../utilities/index.js";
const m = _ref => {
    let {
      color: e = "primary",
      variant: t = "sharp",
      size: r = "lg",
      className: a,
      children: g,
      renderAs: d = "span",
      ...b
    } = _ref;
    const s = p({
      "sash-Badge inline-flex items-center [&_span]:block gap-x-0.5 border py-0.5 px-2 text-subtitle-2 tracking-normal": !0,
      "bg-primary border-primary": e === "primary",
      "bg-red border-[#601414] text-white": e === "danger",
      "bg-blue border-[#0A367A] text-white": e === "info",
      "bg-green border-[#0A420A] text-white": e === "success",
      "bg-gray-5 border-gray-70": e === "light-gray",
      "bg-gray-10 border-gray-60 text-gray-70": e === "gray",
      "bg-gray-75 border-gray-75 text-white": e === "dark-gray",
      "bg-black border-black text-white": e === "black",
      "bg-white border-gray-10 text-gray-90": e === "white",
      "bg-[#1061dd] border-[#1061dd] text-white": e === "blue",
      rounded: t === "rounded",
      "rounded-full": t === "pill",
      "text-sm/[17px]": r === "sm",
      "md:px-2.5 text-sm/[17px] md:text-base/[19px]": r === "md",
      "md:px-2.5 xl:py-1 xl:px-[14px]": r === "lg",
      [a]: a
    });
    return /* @__PURE__ */x(d, {
      className: s,
      ...b,
      children: g
    });
  },
  u = m;
export { u as default };